import React from 'react';
import styled from '@emotion/styled';
import { useStoreActions, useStoreState } from 'easy-peasy';

import ListSearch from '~/core/scripts/components/ListSearch';

const KreisSearchOuter = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 9999999;
  ${({ theme }) => theme.breakpoints.sm.up} {
    justify-content: flex-end;
  }
  opacity: 0;
  transition: opacity 250ms linear, height 250ms ease-in-out;
  pointer-events: none;
  ${({ theme }) => theme.breakpoints.sm.down} {
    height: 0;
  }

  ${({ isDrawingEnabled, theme }) =>
    !isDrawingEnabled &&
    `
      opacity: 1;
      pointer-events: all;
      ${theme.breakpoints.sm.down} {
        height: 65px;
      }
    `}
`;

const KreisSearchInner = styled.div`
  flex-basis: 100%;
  ${({ theme }) => theme.breakpoints.sm.up} {
    max-width: 360px;
    flex-basis: 50%;
  }
`;

const KreisSearch = () => {
  const isDrawingEnabled = useStoreState((state) => state.app.isDrawingEnabled);
  const kreiseGeoJson = useStoreState((state) => state.app.kreiseGeoJson);
  const setKreisSearched = useStoreActions(
    (state) => state.app.setKreisSearched
  );
  const setTooltipStatic = useStoreActions((state) => state.tooltip.setStatic);
  const kreisSearchValue = useStoreState((state) => state.app.kreisSearchValue);
  const setKreisSearchValue = useStoreActions(
    (state) => state.app.setKreisSearchValue
  );

  const simpleListOfKreisNames = kreiseGeoJson.features.map((f) => ({
    name: f.properties.Name,
    id: f.properties.Wahlgebiet_ID,
  }));

  const onSelect = (option) => {
    setTooltipStatic(true);
    setKreisSearched(option === null ? null : option.id);
    setKreisSearchValue(option);
  };

  return (
    <KreisSearchOuter isDrawingEnabled={isDrawingEnabled}>
      <KreisSearchInner>
        <ListSearch
          placeholder="Kreis- oder Stadtnamen eingeben ..."
          onSelect={onSelect}
          data={simpleListOfKreisNames}
          searchPresets={[
            { name: 'Berlin', id: '11000' },
            { name: 'München', id: '09162' },
            { name: 'Vulkaneifel', id: '07233' },
          ]}
          searchPresetsTitle="z.B."
          searchPresetsFieldName="name"
          fieldName="name"
          value={kreisSearchValue}
        />
      </KreisSearchInner>
    </KreisSearchOuter>
  );
};

export default KreisSearch;
